import type { FC } from "react";
import {
  Button,
  type ClassNameProp,
  Flex,
  Icon,
  Indicator,
  Text,
  useHover,
} from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { buttonStyle, textStyle } from "./AnalysisObservationsButton.css";

/**
 * @deprecated
 */
export type AnalysisObservationsButtonProps = ClassNameProp & {
  label: string;
  variant: "previous" | "next";
  onClick?: () => void;
  index: number;
};

/**
 * @deprecated
 */
export const AnalysisObservationsButton: FC<
  AnalysisObservationsButtonProps
> = ({ label, variant, onClick, className, index }) => {
  const { hasHover, handleEnter, handleLeave } = useHover();

  return (
    <Button
      trailing={variant === "next" ? <Icon icon="chevronRight" /> : undefined}
      leading={variant === "previous" ? <Icon icon="chevronLeft" /> : undefined}
      className={mergeClasses(buttonStyle, className)}
      onClick={onClick}
      variant="opaque"
      border="default"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      <Flex
        align="center"
        direction={variant === "previous" ? "row" : "row-reverse"}
        gap="xs"
      >
        <Indicator
          size="xxs"
          inline
          variant={hasHover ? "background" : "secondary"}
        >
          {index + 1}
          {/* {indexToAlpha(index)} */}
        </Indicator>
        <Text
          variant="bodyM"
          className={textStyle}
          align={variant === "previous" ? "left" : "right"}
        >
          {label}
        </Text>
      </Flex>
    </Button>
  );
};
